



import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
 import AgroGenericCard from "@/components/agroGenericCard/AgroGenericCard.vue";
 import * as farmsApi from "@/api/farms";

 @Component({
   name: 'CardFarmsAreaController',
   components: {
     AgroGenericCard,
   }
 })

export default class CardFarmsAreaController extends Vue {
  private isLoading = false;
  private area: number | null = null;
  private unit: string | null = null;

  @Prop({ type: Boolean, default: false }) private onlyUserFarms!: boolean;
  @Prop({ type: Boolean, default: false }) private onlyActiveMonitoring!: boolean;
  @Prop({ type: Boolean, default: false }) private isAddNewFarm!: boolean;
  @Prop({ type: Boolean, default: false }) private isRemovedFarm!: boolean;

  async mounted() {
    await this.getCountFarm();
  };

  @Watch('onlyUserFarms')
  @Watch('onlyActiveMonitoring')
  @Watch('isAddNewFarm')
  @Watch('isRemovedFarm')
  private async getCountFarm() {
    this.isLoading = true;
    try {
      const response = (await farmsApi.getFarmArea(this.onlyUserFarms, this.onlyActiveMonitoring)).data;
      this.area = response.value;
      this.unit = response.unit;
    } catch {
      this.area = null;
    } finally {
      this.isLoading = false;
    }
  }
  
}
